export const SUPPORTED_LOCALES = [ "en", "de" ] as const;

export type TSupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: TSupportedLocale = "en";

export const isSupportedLocale = (locale: string): locale is TSupportedLocale => (
  (SUPPORTED_LOCALES as readonly string[]).includes(locale)
);
